import {
  Component,
  ElementRef,
  NgZone,
  OnInit,
  ViewChild,
} from "@angular/core";
import { NgxSpinnerService } from "ngx-spinner";
import { Router } from "@angular/router";
import {
  FormBuilder,
  FormControl,
  FormGroup,
  Validators,
} from "@angular/forms";

import { ReportEngineService } from "../../../services/report-engine.service";
import { ReportingRuleModel } from "../../../models/reporting-rule-model";
import { Observable } from "rxjs";
import { CoreService } from "../../../services/migrate/api.core.service";
import { USER_DATA } from "../../../utils/constants.util";
import { Empresa } from "../../../models/markerModel";
import { map } from "rxjs/operators";
import Swal from "sweetalert2";
import { ReportEngineModel } from "../../../models/report-engine-model";
import { STORAGE_KEY_CURRENT_USER } from "../../../storageCore/constStorageKeys";
import storageX from "../../../storageCore/storageX";
import { toCamel } from "snake-camel";
import { MapsAPILoader } from "@agm/core";

@Component({
  selector: "app-reporting-mechanism-create",
  templateUrl: "./reporting-mechanism-create.component.html",
  styleUrls: ["./reporting-mechanism-create.component.scss"],
})
export class ReportingMechanismCreateComponent implements OnInit {
  public reportEngineService: ReportEngineService;
  public serviceCore: CoreService;

  latitude: number;
  longitude: number;
  private geoCoder;
  @ViewChild("search") searchElementRef: ElementRef;

  public reportingRuleModelModel: ReportingRuleModel;

  public controlCompany = new FormControl();
  public controlTerminalFilter = new FormControl();

  public companys: any[] = [];
  public companysFiltered = new Observable<Array<any>>();

  public reportTypes: any[] = [];
  public terminals: any[] = [];
  public companiesFilter: any[] = [];
  public companiesSelect: any[] = [];

  public validFieldsReport = [
    { name: "IDTERMINAL", active: false, optional: false },
    { name: "IDMOTORISTA", active: false, optional: false },
    { name: "IDEMPRESA", active: false, optional: false },
    { name: "IDDIVISAO", active: false, optional: false },
    { name: "MODELORELATORIO", active: false, optional: false },
    { name: "DATAINICIO", active: false, optional: false },
    { name: "DATAFIM", active: false, optional: false },
    { name: "MESANOREFERENCIA", active: false, optional: false },
    { name: "XLSX", active: false, optional: false },
    { name: "PDF", active: false, optional: false },
    { name: "SALTOGPS", active: false, optional: false },
    { name: "REMOVERKM", active: false, optional: false },
    { name: "BUSCARDIVISAO", active: false, optional: false },
    { name: "LATITUDE", active: false, optional: false },
    { name: "LONGITUDE", active: false, optional: false },
    { name: "RAIO", active: false, optional: false },
    { name: "IDTERMINALS", active: false, optional: false },
    { name: "VELOCIDADE", active: false, optional: false },
  ];

  public typesReport: any = [
    { name: "RELATORIO POR MOTORISTA", value: "MONTHLY_DRIVER" },
    { name: "RELATORIO POR VEICULO", value: "MONTHLY_VEHICLE" },
  ];

  public reportingRuleForm: FormGroup;

  public typeReportSelected;
  public typeParametersSelected;
  public modelReportSelected;
  public companyFilterSelected;

  public reportEngineModel: ReportEngineModel;

  public errorMessage;
  
    // Propriedade para armazenar dados específicos do relatório
  public reportTypeData: any[] = [];
  
  // Propriedades para dropdowns personalizados do response
  public reportCompanyModelSelected: string = 'company';
  public reportCompanySelected: any = null;
  public reportCompaniesFilter: any[] = [];
  
  // Propriedade para armazenar terminais filtrados por empresa
  public filteredTerminals: any[] = [];
  
  // Propriedade para controlar o loader de filtro de terminais
  public isFilteringTerminals: boolean = false;

  ngOnInit(): void {
    this.loadDataElements();

    this.reportingRuleForm = this.formBuilder.group(
      {
        typeReport: ["", Validators.required],
        selectCompany: [""],
        dateStart: [""],
        dateEnd: [""],
        referenceMonth: [""],
        modelReport: [""],
        latitude: [""],
        longitude: [""],
        radius: [""],
        velocity: [""],
        search: [""],
        filePdf: [false],
        fileExcel: [false],
        gpsJumps: [false],
        removeKm: [false],
        searchDivision: [false],
        terminals: [[]],
        rfidPassenger: [""],
      },
      { updateOn: "blur" }
    );

    this.companysFiltered = this.controlCompany.valueChanges.pipe(
      map((value) => (typeof value === "string" ? value : value.id)),
      map((name) =>
        name ? this.filterValuesCompany(name) : this.companys.slice()
      )
    );

    this.mapsAPILoader.load().then(() => {
      this.geoCoder = new (window as any).google.maps.Geocoder();
      const autocomplete = new (window as any).google.maps.places.Autocomplete(
        this.searchElementRef.nativeElement
      );
      autocomplete.addListener("place_changed", () => {
        this.ngZone.run(() => {
          const place: any = autocomplete.getPlace();
          if (place.geometry === undefined || place.geometry === null) {
            return;
          }
          this.latitude = place.geometry.location.lat();
          this.longitude = place.geometry.location.lng();

          // Define os valores no formulário
          this.reportingRuleForm.get("latitude")?.setValue(this.latitude);
          // Adicione longitude se houver campo
          this.reportingRuleForm.get("longitude")?.setValue(this.longitude);
        });
      });
    });
  }

  constructor(
    private formBuilder: FormBuilder,
    private router: Router,
    private spinner: NgxSpinnerService,
    private mapsAPILoader: MapsAPILoader,
    private ngZone: NgZone,
    reportEngineService: ReportEngineService,
    apiserviceCore: CoreService
  ) {
    this.reportEngineService = reportEngineService;
    this.serviceCore = apiserviceCore;
  }

  onTypeReportChange(event: any): void {
    this.spinner.show();
    const selectedTypeUuid = event.value;
    
    // Limpar filtro de terminais quando o tipo de relatório mudar
    this.controlTerminalFilter?.setValue("");

    this.reportEngineService
      .getByUuidParametersField(selectedTypeUuid)
      .subscribe(
        (response) => {
          console.log("Dados recebidos:", response);
          this.validateFields(response);
          this.spinner.hide();
        },
        (error) => {
          console.error("Erro ao buscar o relatório:", error);
          this.spinner.hide();
        }
      );

    this.reportEngineService
      .getByReportTypeParameters(selectedTypeUuid, USER_DATA().profileId)
      .subscribe(
        (response) => {
          console.log("Dados específicos do relatório:", response);
          
                     // Verificar se a resposta não é null e tem dados
           if (response && Array.isArray(response) && response.length > 0) {
             console.log(`Encontrados ${response.length} registros para preenchimento automático`);
             this.fillFormFieldsWithReportData(response);
           } else {
             console.log("Nenhum dado encontrado para preenchimento automático");
             this.resetReportSpecificFields();
           }
          
          this.spinner.hide();
        },
        (error) => {
          console.error("Erro ao buscar dados específicos do relatório:", error);
          this.spinner.hide();
        }
      );
  }

  /**
   * Preenche automaticamente os campos do formulário com os dados do relatório
   * 
   * @param reportData Array de dados retornados pelo endpoint
   */
  private fillFormFieldsWithReportData(reportData: any[]): void {
    try {
      // Armazenar dados do relatório
      this.reportTypeData = reportData;
      
      // Popular empresas diretamente no companiesFilter (seguindo padrão do filterCompany)
      this.populateCompaniesFromResponse(reportData);
      
      // Popular terminais no array terminals
      this.populateTerminalsFromResponse(reportData);
      
      // Inicializar dropdowns personalizados
      this.initializeReportDropdowns();
      
      console.log(`Dados configurados: ${this.companiesFilter.length} empresas, ${this.terminals.length} terminais`);
      
    } catch (error) {
      console.error("Erro ao configurar dados do relatório:", error);
    }
  }

  /**
   * Inicializa os dropdowns personalizados para dados do response
   */
  private initializeReportDropdowns(): void {
    // Resetar seleções
    this.reportCompanyModelSelected = 'company';
    this.reportCompanySelected = null;
    this.filteredTerminals = [];
    this.isFilteringTerminals = false;
    
    // Filtrar empresas iniciais (por padrão, empresas)
    this.filterReportCompanies();
    
    console.log('Dropdowns personalizados inicializados');
  }

  /**
   * Reseta campos específicos do relatório quando não há dados do response
   */
  private resetReportSpecificFields(): void {
    console.log('=== RESETANDO CAMPOS ESPECÍFICOS DO RELATÓRIO ===');
    
    // Limpar dados do relatório
    this.reportTypeData = [];
    
    // Restaurar companiesFilter para estado padrão (todas as empresas)
    this.companiesFilter = this.companys;
    
         // Restaurar terminals para estado padrão (todos os terminais)
     // Carregar novamente todos os terminais do serviço
     this.reportEngineService.getByTerminals().subscribe(
       (terminals) => {
         this.terminals = terminals;
         console.log('Terminais restaurados para estado padrão:', this.terminals.length);
       },
       (error) => {
         console.error('Erro ao restaurar terminais:', error);
         this.terminals = [];
       }
     );
    
    // Limpar terminais filtrados
    this.filteredTerminals = [];
    
    // Limpar dropdowns personalizados
    this.reportCompanyModelSelected = 'company';
    this.reportCompanySelected = null;
    this.reportCompaniesFilter = [];
    this.isFilteringTerminals = false;
    
    // Limpar seleções do formulário
    this.controlCompany.setValue("");
    this.reportingRuleForm.get('terminals')?.setValue([]);
    
    // Limpar seleções de dropdowns padrão
    this.companyFilterSelected = null;
    this.reportingRuleForm.get('selectCompany')?.setValue("");
    
    // Limpar seleções de modelo de relatório
    this.modelReportSelected = null;
    this.reportingRuleForm.get('modelReport')?.setValue("");
    
    // Limpar datas
    this.reportingRuleForm.get('dateStart')?.setValue("");
    this.reportingRuleForm.get('dateEnd')?.setValue("");
    
    // Limpar campos de localização
    this.reportingRuleForm.get('latitude')?.setValue("");
    this.reportingRuleForm.get('longitude')?.setValue("");
    this.reportingRuleForm.get('radius')?.setValue("");
    this.reportingRuleForm.get('velocity')?.setValue("");
    
    // Limpar campos de opções
    this.reportingRuleForm.get('filePdf')?.setValue(false);
    this.reportingRuleForm.get('fileExcel')?.setValue(false);
    this.reportingRuleForm.get('gpsJumps')?.setValue(false);
    this.reportingRuleForm.get('removeKm')?.setValue(false);
    this.reportingRuleForm.get('searchDivision')?.setValue(false);
    
    // Limpar campo RFID
    this.reportingRuleForm.get('rfidPassenger')?.setValue("");
    
    // Limpar filtro de terminais
    this.controlTerminalFilter?.setValue("");
    
    console.log('Todos os campos específicos do relatório foram resetados');
    console.log('=== FIM RESET ===');
  }

  /**
   * Popula empresas diretamente no companiesFilter usando dados do response
   * SUBSTITUI completamente o companiesFilter pelos dados do response
   * 
   * @param reportData Dados do relatório
   */
  private populateCompaniesFromResponse(reportData: any[]): void {
    // LIMPAR completamente o companiesFilter
    this.companiesFilter = [];
    
    // Extrair empresas e divisões únicas dos dados
    const companiesMap = new Map();
    
    reportData.forEach(item => {
      if (item.companyId && item.nameCompany) {
        companiesMap.set(item.companyId, {
          id: item.companyId,
          nmNome: item.nameCompany,
          type: 'company'
        });
      }
      
      if (item.divisionId && item.nameDivision) {
        companiesMap.set(item.divisionId, {
          id: item.divisionId,
          nmNome: item.nameDivision,
          type: 'division'
        });
      }
    });
    
    // SUBSTITUIR completamente o companiesFilter pelos dados do response
    this.companiesFilter = Array.from(companiesMap.values());
    
    // Ordenar por nome
    this.companiesFilter.sort((a, b) => a.nmNome.localeCompare(b.nmNome));
    
    // Limpar o campo de empresa selecionada
    this.controlCompany.setValue("");
    
    console.log(`Empresas SUBSTITUÍDAS pelo response: ${this.companiesFilter.length} empresas/divisões`);
    console.log('Empresas disponíveis:', this.companiesFilter.map(c => c.nmNome));
  }

  /**
   * Popula terminais no array terminals usando dados do response
   * SUBSTITUI completamente os terminais pelos dados do response
   * 
   * @param reportData Dados do relatório
   */
  private populateTerminalsFromResponse(reportData: any[]): void {
    console.log('=== DEBUG POPULATE TERMINALS ===');
    console.log('Dados do response recebidos:', reportData);
    
    // LIMPAR completamente o array de terminais
    this.terminals = [];
    
    const terminalsMap = new Map();
    
    // Extrair terminais únicos
    reportData.forEach((item, index) => {
      console.log(`Item ${index}:`, item);
      if (item.terminalId && item.plate) {
        const terminal = {
          id: item.terminalId,
          cdPlaca: item.plate,
          name: item.plate,
          companyId: item.companyId,
          divisionId: item.divisionId,
          // Adicionar campos adicionais para debug
          batteryLevel: item.batteryLevel,
          modelTracker: item.modelTracker,
          modelVehicle: item.modelVehicle
        };
        console.log(`Terminal criado:`, terminal);
        console.log(`  - companyId: ${terminal.companyId} (${typeof terminal.companyId})`);
        console.log(`  - divisionId: ${terminal.divisionId} (${typeof terminal.divisionId})`);
        terminalsMap.set(item.terminalId, terminal);
      } else {
        console.log(`Item ${index} ignorado - sem terminalId ou plate`);
      }
    });
    
    // SUBSTITUIR completamente os terminais pelos dados do response
    this.terminals = Array.from(terminalsMap.values());
    
    // Ordenar terminais por placa
    this.terminals.sort((a, b) => a.cdPlaca.localeCompare(b.cdPlaca));
    
    // Limpar seleção de terminais
    this.reportingRuleForm.get('terminals')?.setValue([]);
    this.filteredTerminals = [];
    
    // Limpar filtro de busca de terminais
    this.controlTerminalFilter?.setValue("");
    
    console.log(`Terminais SUBSTITUÍDOS pelo response: ${this.terminals.length} terminais`);
    console.log('Terminais disponíveis:', this.terminals);
    console.log('=== FIM DEBUG POPULATE ===');
  }

  /**
   * Filtra terminais por empresa selecionada
   * 
   * @param companyId ID da empresa selecionada
   */
  public filterTerminalsByCompany(
    companyId: number,
    includeLinkedDivisions: boolean = false
  ): void {
    console.log('=== DEBUG FILTER TERMINALS ===');
    console.log('CompanyId recebido:', companyId, 'Tipo:', typeof companyId);
    console.log('Incluir divisões vinculadas:', includeLinkedDivisions);
    console.log('Terminais disponíveis:', this.terminals.length);
    console.log('Todos os terminais:', this.terminals);
    
    if (!this.terminals || this.terminals.length === 0) {
      console.log('Nenhum terminal disponível');
      this.filteredTerminals = [];
      return;
    }
    
    const selectedCompany = this.companiesFilter.find(c => c.id === companyId);
    console.log('Empresa selecionada:', selectedCompany);
    const isDivision = selectedCompany?.type === 'division';
    console.log('É divisão?', isDivision);
    const linkedDivisionIds = includeLinkedDivisions
      ? this.getDivisionsLinkedToCompany(companyId)
      : [];
    
    this.filteredTerminals = this.terminals.filter(terminal => {
      console.log(`Verificando terminal ${terminal.cdPlaca}:`);
      console.log(`  - Terminal companyId: ${terminal.companyId} (${typeof terminal.companyId})`);
      console.log(`  - Terminal divisionId: ${terminal.divisionId} (${typeof terminal.divisionId})`);
      console.log(`  - CompanyId procurado: ${companyId} (${typeof companyId})`);
      
      let matches = false;
      
      if (isDivision) {
        matches = terminal.divisionId == companyId;
        console.log(`  - Divisão match: ${matches}`);
      } else if (includeLinkedDivisions && linkedDivisionIds.length > 0) {
        matches =
          terminal.companyId == companyId ||
          linkedDivisionIds.some(
            (divisionId) => terminal.divisionId == divisionId
          );
        console.log(`  - Empresa/divisões vinculadas match: ${matches}`);
      } else {
        if (terminal.divisionId == null) {
          matches = terminal.companyId == companyId;
          console.log(`  - Empresa direta match: ${matches}`);
        } else {
          matches = false;
          console.log(`  - Terminal em divisão, não aparece na empresa: ${matches}`);
        }
      }
      
      return matches;
    });
    
    console.log(`Terminais filtrados para empresa ${companyId}: ${this.filteredTerminals.length}`);
    console.log('Terminais filtrados:', this.filteredTerminals.map(t => t.cdPlaca));
    console.log('=== FIM DEBUG ===');
  }

  /**
   * Handler para mudança de empresa selecionada no autocomplete
   * 
   * @param event Evento de seleção
   */
  public onCompanySelectionChange(event: any): void {
    console.log('onCompanySelectionChange chamado:', event);
    const selectedCompany = event.option.value;
    console.log('Empresa selecionada:', selectedCompany);
    
    if (selectedCompany && selectedCompany.id) {
      console.log(`Filtrando terminais para empresa ID: ${selectedCompany.id} - Nome: ${selectedCompany.nmNome}`);
      this.filterTerminalsByCompany(
        selectedCompany.id,
        this.isSearchDivisionEnabled()
      );
      
      // Limpar seleção de terminais
      this.reportingRuleForm.get('terminals')?.setValue([]);
      // Limpar filtro de busca de terminais
      this.controlTerminalFilter?.setValue("");
    } else {
      console.log('Nenhuma empresa selecionada - limpando terminais filtrados');
      this.filteredTerminals = [];
      // Limpar filtro de busca de terminais
      this.controlTerminalFilter?.setValue("");
    }
  }

  /**
   * Verifica se há dados do response para ocultar o dropdown "Modelo de Empresa"
   * 
   * @returns true se há dados do response
   */
  public hasReportTypeData(): boolean {
    return this.reportTypeData && this.reportTypeData.length > 0;
  }

  /**
   * Handler para mudança do modelo de empresa no dropdown personalizado
   * 
   * @param event Evento de seleção
   */
  public onReportCompanyModelChange(event: any): void {
    // Método não utilizado mais - dropdown único de empresas/divisões
  }

  /**
   * Handler para seleção de empresa no dropdown personalizado
   * 
   * @param event Evento de seleção
   */
  public onReportCompanySelectionChange(event: any): void {
    console.log('Empresa selecionada no dropdown personalizado:', event.value);
    this.reportCompanySelected = event.value;
    
    if (this.reportCompanySelected && this.reportCompanySelected.id) {
      // Ativar loader
      this.isFilteringTerminals = true;
      
      // Simular delay para mostrar o loader
      setTimeout(() => {
        this.filterTerminalsFromResponse(this.reportCompanySelected.id);
        this.isFilteringTerminals = false;
      }, 500);
    } else {
      this.filteredTerminals = [];
      // Limpar filtro de busca de terminais
      this.controlTerminalFilter?.setValue("");
    }
  }

  /**
   * Filtra empresas do response baseado no modelo selecionado
   */
  private filterReportCompanies(): void {
    if (!this.reportTypeData || this.reportTypeData.length === 0) {
      this.reportCompaniesFilter = [];
      return;
    }

    // Buscar todas as empresas e divisões únicas
    const companies = this.reportTypeData
      .filter(item => item.divisionId === null)
      .map(item => ({
        id: item.companyId,
        nmNome: item.nameCompany,
        type: 'company'
      }));

    const divisions = this.reportTypeData
      .filter(item => item.divisionId !== null)
      .map(item => ({
        id: item.divisionId,
        nmNome: item.nameDivision,
        type: 'division'
      }));

    // Combinar e remover duplicatas
    this.reportCompaniesFilter = [...companies, ...divisions]
      .filter((item, index, self) => 
        index === self.findIndex(i => i.id === item.id)
      );

    // Ordenar por nome
    this.reportCompaniesFilter.sort((a, b) => a.nmNome.localeCompare(b.nmNome));
    
    console.log('Empresas e divisões filtradas:', this.reportCompaniesFilter.length);
  }

  /**
   * Filtra terminais do response baseado na empresa selecionada
   * 
   * @param companyId ID da empresa/divisão selecionada
   */
  private filterTerminalsFromResponse(companyId: number): void {
    console.log('=== FILTRANDO TERMINAIS DO RESPONSE ===');
    console.log('CompanyId:', companyId, 'Tipo:', typeof companyId);
    
    if (!this.reportTypeData || this.reportTypeData.length === 0) {
      console.log('Nenhum dado do response disponível');
      this.filteredTerminals = [];
      return;
    }
    
    // Filtrar terminais do response baseado na empresa/divisão selecionada
    this.filteredTerminals = this.reportTypeData
      .filter(item => {
        // Verificar se o terminal pertence à empresa/divisão selecionada
        return item.companyId === companyId || item.divisionId === companyId;
      })
      .map(item => ({
        id: item.terminalId,
        cdPlaca: item.plate,
        name: item.plate,
        companyId: item.companyId,
        divisionId: item.divisionId,
        batteryLevel: item.batteryLevel,
        modelTracker: item.modelTracker,
        modelVehicle: item.modelVehicle
      }));
    
    // Ordenar por placa
    this.filteredTerminals.sort((a, b) => a.cdPlaca.localeCompare(b.cdPlaca));
    
    console.log(`Terminais filtrados: ${this.filteredTerminals.length}`);
    console.log('Terminais encontrados:', this.filteredTerminals.map(t => t.cdPlaca));
    console.log('=== FIM FILTRO ===');
  }

  /**
   * Alterna entre selecionar todos ou desmarcar todos os terminais
   */
  public toggleSelectAllTerminals(): void {
    console.log('=== ALTERNANDO SELEÇÃO DE TERMINAIS ===');
    
    const availableTerminals = this.getAvailableTerminals();
    
    if (availableTerminals.length === 0) {
      console.log('Nenhum terminal disponível para seleção');
      return;
    }
    
    const currentSelection = this.reportingRuleForm.get('terminals')?.value || [];
    const allTerminalIds = availableTerminals.map(terminal => terminal.id);
    
    // Verificar se todos os terminais disponíveis estão selecionados
    const allSelected = allTerminalIds.every(id => currentSelection.includes(id));
    
    if (allSelected) {
      // Se todos estão selecionados, desmarcar todos
      this.reportingRuleForm.get('terminals')?.setValue([]);
      console.log('Todos os terminais foram desmarcados');
    } else {
      // Se não todos estão selecionados, selecionar todos
      this.reportingRuleForm.get('terminals')?.setValue(allTerminalIds);
      console.log(`Selecionados ${allTerminalIds.length} terminais:`, allTerminalIds);
    }
    
    console.log('=== FIM ALTERNAÇÃO ===');
  }

  /**
   * Verifica se todos os terminais disponíveis estão selecionados
   * 
   * @returns true se todos os terminais estão selecionados
   */
  public isAllTerminalsSelected(): boolean {
    const availableTerminals = this.getAvailableTerminals();
    
    if (availableTerminals.length === 0) {
      return false;
    }
    
    const currentSelection = this.reportingRuleForm.get('terminals')?.value || [];
    const allTerminalIds = availableTerminals.map(terminal => terminal.id);
    
    // Verificar se todos os terminais disponíveis estão selecionados
    return allTerminalIds.every(id => currentSelection.includes(id));
  }

  /**
   * Verifica se é o relatório de embarque de passageiros
   * @returns true se for o relatório de embarque de passageiros
   */
  public isPassengerBoardingReport(): boolean {
    if (!this.typeReportSelected) return false;
    
    const selectedReportType = this.reportTypes.find(
      (report) => report.uuid === this.typeReportSelected
    );
    
    return selectedReportType?.name?.toLowerCase().includes('embarque de passageiros') || false;
  }

  public isAnalyticalCustomReport(): boolean {
    if (!this.typeReportSelected) {
      return false;
    }
    const selectedReportType = this.reportTypes.find(
      (report) => report.uuid === this.typeReportSelected
    );
    return selectedReportType?.report_template === "ANALYTICAL_CUSTOM";
  }

  private isCustomPeriodWithin15Days(dateStart: string, dateEnd: string): boolean {
    const start = new Date(dateStart);
    const end = new Date(dateEnd);
    if (isNaN(start.getTime()) || isNaN(end.getTime()) || end <= start) {
      return false;
    }
    const maxMs = 15 * 24 * 60 * 60 * 1000;
    return end.getTime() - start.getTime() <= maxMs;
  }

  /**
   * Retorna os terminais disponíveis para o dropdown
   * Se há dados do response e empresa selecionada, retorna terminais filtrados
   * Se há dados do response mas não há empresa selecionada, retorna array vazio
   * Se NÃO há dados do response, retorna todos os terminais (fluxo antigo)
   * Aplica pré-filtro para terminais que terminam com "RF" se for relatório de embarque de passageiros
   * Aplica filtro de busca por placa se houver texto no campo de filtro
   * 
   * @returns Array de terminais disponíveis
   */
  public getAvailableTerminals(): any[] {
    let availableTerminals: any[] = [];
    
    // Se há dados do response
    if (this.hasReportTypeData()) {
      // Se há terminais filtrados, usar os filtrados
      if (this.filteredTerminals.length > 0) {
        console.log('Retornando terminais filtrados do response:', this.filteredTerminals.map(t => t.cdPlaca));
        availableTerminals = this.filteredTerminals;
      } else {
        // Se não há empresa selecionada, retornar array vazio
        console.log('Nenhum terminal disponível - empresa não selecionada no response');
        return [];
      }
    } else {
      // NÃO há dados do response - seguir fluxo antigo
      console.log('NÃO há dados do response - usando fluxo antigo (todos os terminais)');
      console.log('Retornando todos os terminais:', this.terminals.map(t => t.cdPlaca));
      availableTerminals = this.terminals;
    }
    
    // Aplicar pré-filtro para relatório de embarque de passageiros (terminais que terminam com "RF")
    if (this.isPassengerBoardingReport()) {
      console.log('Aplicando pré-filtro: apenas terminais que terminam com "RF"');
      availableTerminals = availableTerminals.filter(terminal => 
        terminal.cdPlaca && terminal.cdPlaca.toUpperCase().endsWith('RF')
      );
      console.log(`Terminais após pré-filtro RF: ${availableTerminals.length}`, availableTerminals.map(t => t.cdPlaca));
    }
    
    // Aplicar filtro de busca por placa se houver texto
    const filterText = this.controlTerminalFilter?.value || '';
    if (filterText && filterText.trim() !== '') {
      const searchText = filterText.toLowerCase().trim();
      availableTerminals = availableTerminals.filter(terminal => 
        terminal.cdPlaca && terminal.cdPlaca.toLowerCase().includes(searchText)
      );
    }
    
    return availableTerminals;
  }

  public filterValuesCompany(value: any): Array<any> {
    const filterValue = value;

    return this.companys
      .sort((a, b) => a.nmNome.localeCompare(b.nmNome))
      .filter((client) => client.nmNome.toLowerCase().includes(filterValue));
  }

  displayCompany(empresa: Empresa): string {
    return empresa && empresa.nmNome ? empresa.nmNome : "";
  }

  validateFields(response: any): void {
    console.log('=== VALIDANDO CAMPOS DO RELATÓRIO ===');
    
    const currentTypeReportValue =
      this.reportingRuleForm.get("typeReport")?.value;
    this.reportingRuleForm.reset({ typeReport: currentTypeReportValue });
    this.resetFields();

    response.forEach((field: any) => {
      const matchingField = this.validFieldsReport.find(
        (item) => item.name === field.field_name
      );

      if (matchingField) {
        matchingField.active = true;
        matchingField.optional = field.field_optional ?? matchingField.optional;

        // Configura valor true e desabilita se optional for false
        if (field.field_name === "PDF") {
          this.reportingRuleForm
            .get("filePdf")
            ?.setValue(!field.field_optional);
        }
        if (field.field_name === "XLSX") {
          this.reportingRuleForm
            .get("fileExcel")
            ?.setValue(!field.field_optional);
        }
        if (field.field_name === "SALTOGPS") {
          this.reportingRuleForm
            .get("gpsJumps")
            ?.setValue(!field.field_optional);
        }
        if (field.field_name === "REMOVERKM") {
          this.reportingRuleForm
            .get("removeKm")
            ?.setValue(!field.field_optional);
        }
        if (field.field_name === "BUSCARDIVISAO") {
          this.reportingRuleForm
            .get("searchDivision")
            ?.setValue(!field.field_optional);
        }
      }
    });
    
    console.log('Campos do relatório validados');
    console.log('=== FIM VALIDAÇÃO ===');
  }

  public resetFields() {
    this.validFieldsReport = [
      { name: "IDTERMINAL", active: false, optional: false },
      { name: "IDMOTORISTA", active: false, optional: false },
      { name: "IDEMPRESA", active: false, optional: false },
      { name: "IDDIVISAO", active: false, optional: false },
      { name: "MODELORELATORIO", active: false, optional: false },
      { name: "DATAINICIO", active: false, optional: false },
      { name: "DATAFIM", active: false, optional: false },
      { name: "MESANOREFERENCIA", active: false, optional: false },
      { name: "XLSX", active: false, optional: false },
      { name: "PDF", active: false, optional: false },
      { name: "SALTOGPS", active: false, optional: false },
      { name: "REMOVERKM", active: false, optional: false },
      { name: "BUSCARDIVISAO", active: false, optional: false },
      { name: "LATITUDE", active: false, optional: false },
      { name: "LONGITUDE", active: false, optional: false },
      { name: "RAIO", active: false, optional: false },
      { name: "IDTERMINALS", active: false, optional: false },
      { name: "VELOCIDADE", active: false, optional: false },
      { name: "RFIDPASSAGEIRO", active: false, optional: false },
    ];
  }

  public async loadDataElements() {
    try {
      this.spinner.show();

      this.reportEngineService.getByReportTypes().subscribe(
        (t) => {
          this.reportTypes = t;
          this.spinner.hide();
        },
        (error) => {
          console.log("Erro ao obter as informações");
          this.spinner.hide();
        }
      );

      this.reportEngineService.getByTerminals().subscribe(
        (t) => {
          this.terminals = t;
          this.spinner.hide();
        },
        (error) => {
          console.log("Erro ao obter as informações");
          this.spinner.hide();
        }
      );

      const companys = await this.serviceCore.get<any>({
        url: "v2/companys",
        params: {
          profileId: USER_DATA().profileId,
          size: "5000",
          page: "0",
          sort: "nome",
          sortDirections: "ASC",
        },
      });

      this.companys = companys?.elements;
      this.companys = this.companys.sort((a, b) =>
        a.nmNome.localeCompare(b.nmNome)
      );
      this.controlCompany.setValue("");

      this.companiesSelect = [
        { name: "Divisão", value: 1 },
        { name: "Matriz", value: 2 },
        { name: "Filial", value: 3 },
      ];

      this.spinner.hide();
    } catch (error) {
      this.spinner.hide();
      throw new EvalError(error);
    }
  }

  public filterCompany() {
    // NÃO executar se temos dados do response (reportTypeData)
    if (this.reportTypeData && this.reportTypeData.length > 0) {
      console.log('Ignorando filterCompany() - usando dados do response');
      return;
    }
    
    this.controlCompany.setValue("");
    var companyModel = this.companyFilterSelected;
    var empresas = [];

    if (companyModel == "Divisão") {
      this.companys.forEach((element) => {
        if (element.cnpj == null) {
          empresas.push(element);
        }
      });
    }

    if (companyModel == "Matriz") {
      this.companys.forEach((element) => {
        if (element.cnpj != null && element.idEmpresaMatriz == null) {
          empresas.push(element);
        }
      });
    }

    if (companyModel == "Filial") {
      this.companys.forEach((element) => {
        if (element.cnpj != null && element.idEmpresaMatriz != null) {
          empresas.push(element);
        }
      });
    }

    this.companiesFilter = empresas;

    this.companysFiltered.subscribe((filteredCompanies) => {
      this.companiesFilter = filteredCompanies;
    });
  }

  /** Limite do datetime-local: ontem 23:59 (dia atual não permitido). */
  get maxClosedDateTime(): string {
    const yesterday = new Date();
    yesterday.setDate(yesterday.getDate() - 1);
    yesterday.setHours(23, 59, 0, 0);
    const month = String(yesterday.getMonth() + 1).padStart(2, "0");
    const day = String(yesterday.getDate()).padStart(2, "0");
    return `${yesterday.getFullYear()}-${month}-${day}T23:59`;
  }

  /** Último mês fechado (mês anterior ao corrente). */
  get maxReferenceMonth(): string {
    return this.formatYearMonth(this.lastClosedMonthDate());
  }

  private lastClosedMonthDate(): Date {
    const now = new Date();
    return new Date(now.getFullYear(), now.getMonth() - 1, 1);
  }

  private formatYearMonth(date: Date): string {
    const month = String(date.getMonth() + 1).padStart(2, "0");
    return `${date.getFullYear()}-${month}`;
  }

  private isClosedReferenceMonth(yearMonth: string): boolean {
    if (!/^(\d{4})-(\d{2})$/.test(yearMonth)) {
      return false;
    }
    return yearMonth <= this.maxReferenceMonth;
  }

  private closedMonthRangeFromYearMonth(yearMonth: string): {
    start: string;
    end: string;
  } {
    const match = /^(\d{4})-(\d{2})$/.exec(yearMonth);
    if (!match) {
      return { start: "", end: "" };
    }
    const year = Number(match[1]);
    const month = Number(match[2]);
    if (month < 1 || month > 12) {
      return { start: "", end: "" };
    }
    const lastDay = new Date(year, month, 0).getDate();
    const mm = String(month).padStart(2, "0");
    const dd = String(lastDay).padStart(2, "0");
    return {
      start: `${year}-${mm}-01T00:00:01`,
      end: `${year}-${mm}-${dd}T23:59:59`,
    };
  }

  /**
   * Formata uma data do formato datetime-local para ISO 8601
   * Garante formatação consistente independente do locale do sistema
   * 
   * @param dateValue Valor do input datetime-local (formato: YYYY-MM-DDTHH:mm)
   * @returns String formatada no formato ISO 8601 (YYYY-MM-DDTHH:mm:ss)
   */
  private formatDateForApi(dateValue: string): string {
    if (!dateValue || dateValue.trim() === '') {
      return '';
    }

    try {
      // O datetime-local sempre retorna no formato YYYY-MM-DDTHH:mm
      // Usar Date para garantir parsing correto independente do locale
      const date = new Date(dateValue);
      
      // Verificar se a data é válida
      if (isNaN(date.getTime())) {
        console.error('Data inválida:', dateValue);
        return '';
      }

      // Formatar usando métodos do Date para garantir formato ISO 8601
      const year = date.getFullYear();
      const month = String(date.getMonth() + 1).padStart(2, '0');
      const day = String(date.getDate()).padStart(2, '0');
      const hours = String(date.getHours()).padStart(2, '0');
      const minutes = String(date.getMinutes()).padStart(2, '0');
      
      return `${year}-${month}-${day}T${hours}:${minutes}:01`;
    } catch (error) {
      console.error('Erro ao formatar data:', error, dateValue);
      return '';
    }
  }

  /**
   * Formata data para início do dia (00:00:01)
   * 
   * @param dateValue Valor do input datetime-local
   * @returns String formatada no formato ISO 8601 com hora 00:00:01
   */
  private formatDateStartForMonthly(dateValue: string): string {
    if (!dateValue || dateValue.trim() === '') {
      return '';
    }

    try {
      const date = new Date(dateValue);
      
      if (isNaN(date.getTime())) {
        console.error('Data inválida:', dateValue);
        return '';
      }

      const year = date.getFullYear();
      const month = String(date.getMonth() + 1).padStart(2, '0');
      const day = String(date.getDate()).padStart(2, '0');
      
      return `${year}-${month}-${day}T00:00:01`;
    } catch (error) {
      console.error('Erro ao formatar data início mensal:', error, dateValue);
      return '';
    }
  }

  /**
   * Formata data para fim do dia (23:59:59)
   * 
   * @param dateValue Valor do input datetime-local
   * @returns String formatada no formato ISO 8601 com hora 23:59:59
   */
  private formatDateEndForMonthly(dateValue: string): string {
    if (!dateValue || dateValue.trim() === '') {
      return '';
    }

    try {
      const date = new Date(dateValue);
      
      if (isNaN(date.getTime())) {
        console.error('Data inválida:', dateValue);
        return '';
      }

      const year = date.getFullYear();
      const month = String(date.getMonth() + 1).padStart(2, '0');
      const day = String(date.getDate()).padStart(2, '0');
      
      return `${year}-${month}-${day}T23:59:59`;
    } catch (error) {
      console.error('Erro ao formatar data fim mensal:', error, dateValue);
      return '';
    }
  }

  /**
   * Formata data final para relatórios não mensais
   * 
   * @param dateValue Valor do input datetime-local
   * @returns String formatada no formato ISO 8601 com segundos :59
   */
  private formatDateEndForApi(dateValue: string): string {
    if (!dateValue || dateValue.trim() === '') {
      return '';
    }

    try {
      const date = new Date(dateValue);
      
      if (isNaN(date.getTime())) {
        console.error('Data inválida:', dateValue);
        return '';
      }

      const year = date.getFullYear();
      const month = String(date.getMonth() + 1).padStart(2, '0');
      const day = String(date.getDate()).padStart(2, '0');
      const hours = String(date.getHours()).padStart(2, '0');
      const minutes = String(date.getMinutes()).padStart(2, '0');
      
      return `${year}-${month}-${day}T${hours}:${minutes}:59`;
    } catch (error) {
      console.error('Erro ao formatar data fim:', error, dateValue);
      return '';
    }
  }

  public async submitForm(): Promise<void> {
    this.spinner.show();

    const values = this.reportingRuleForm.value;

    var dateStart: string;
    var dateEnd: string;

    let selectedReportType = this.reportTypes.find(
      (report) => report.uuid === this.typeReportSelected
    );
    console.log(selectedReportType);
    
    // Validar e formatar datas
    console.log('=== FORMATANDO DATAS ===');
    console.log('dateStart original:', values.dateStart);
    console.log('dateEnd original:', values.dateEnd);
    console.log('report_template:', selectedReportType?.report_template);
    
    let referenceMonthYear: string | undefined;

    if (this.isReferenceMonthVisible()) {
      referenceMonthYear = (values.referenceMonth || "").trim();
      if (!referenceMonthYear) {
        this.errorMessage =
          "Informe o mês e ano de referência para o relatório mensal.";
        this.spinner.hide();
        return;
      }
      if (!this.isClosedReferenceMonth(referenceMonthYear)) {
        this.errorMessage =
          "Selecione um mês já encerrado. O mês corrente ainda não pode ser usado.";
        this.spinner.hide();
        return;
      }
      const closed = this.closedMonthRangeFromYearMonth(referenceMonthYear);
      dateStart = closed.start;
      dateEnd = closed.end;
    } else if (selectedReportType?.report_template == "ANALYTICAL_CUSTOM") {
      dateStart = this.formatDateForApi(values.dateStart);
      dateEnd = this.formatDateEndForApi(values.dateEnd);
    } else if (selectedReportType?.report_template == "ANALYTICAL_MONTHLY") {
      dateStart = this.formatDateStartForMonthly(values.dateStart);
      dateEnd = this.formatDateEndForMonthly(values.dateEnd);
    } else {
      dateStart = this.formatDateForApi(values.dateStart);
      dateEnd = this.formatDateEndForApi(values.dateEnd);
    }
    
    // Validar se as datas foram formatadas corretamente
    if (!dateStart || dateStart === '' || dateStart.includes('NaN')) {
      console.error('Erro: dateStart inválida após formatação');
      this.errorMessage = 'Data de início inválida. Por favor, verifique o formato da data.';
      this.spinner.hide();
      return;
    }
    
    if (!dateEnd || dateEnd === '' || dateEnd.includes('NaN')) {
      console.error('Erro: dateEnd inválida após formatação');
      this.errorMessage = 'Data de fim inválida. Por favor, verifique o formato da data.';
      this.spinner.hide();
      return;
    }

    if (this.isAnalyticalCustomReport()) {
      const start = new Date(dateStart);
      const end = new Date(dateEnd);
      if (isNaN(start.getTime()) || isNaN(end.getTime()) || end <= start) {
        this.errorMessage = "A data/hora fim deve ser posterior à data/hora início.";
        this.spinner.hide();
        return;
      }
      const today = new Date();
      today.setHours(0, 0, 0, 0);
      const startDay = new Date(start);
      startDay.setHours(0, 0, 0, 0);
      const endDay = new Date(end);
      endDay.setHours(0, 0, 0, 0);
      if (startDay.getTime() >= today.getTime() || endDay.getTime() >= today.getTime()) {
        this.errorMessage =
          "Não é permitido selecionar a data de hoje nem datas futuras. Use até D-1.";
        this.spinner.hide();
        return;
      }
      if (!this.isCustomPeriodWithin15Days(dateStart, dateEnd)) {
        this.errorMessage =
          "O relatório personalizado aceita no máximo 15 dias entre início e fim.";
        this.spinner.hide();
        return;
      }
    }
    
    console.log('dateStart formatada:', dateStart);
    console.log('dateEnd formatada:', dateEnd);
    console.log('=== FIM FORMATAÇÃO ===');

         let companyId: string = "NULL";
     let divisionId: string = "NULL";
     let gpsJump: String = values.gpsJumps;
     let removeKm: String = values.removeKm;
     let searchDivision: String = values.searchDivision;
     let filePdf: String = values.filePdf;
     let fileExcel: String = values.fileExcel;
     let latitude: String = values.latitude;
     let longitude: String = values.longitude;
     let radius: String = values.radius;
     let velocity: String = values.velocity;
           let terminals: any = values.terminals;
     let rfidPassenger: String = values.rfidPassenger;
     
     // Verificar se estamos usando dados do response (dropdowns personalizados)
     if (this.hasReportTypeData() && this.reportCompanySelected) {
       console.log('=== CONFIGURANDO EMPRESA/DIVISÃO DO RESPONSE ===');
       console.log('Empresa/Divisão selecionada:', this.reportCompanySelected);
       console.log('Modelo selecionado:', this.reportCompanyModelSelected);
       
       if (this.reportCompanyModelSelected === 'company') {
         // Se selecionou uma empresa, usar IDEMPRESA
         companyId = this.reportCompanySelected.id.toString();
         divisionId = "NULL";
         console.log(`Configurado IDEMPRESA: ${companyId}, IDDIVISAO: NULL`);
       } else if (this.reportCompanyModelSelected === 'division') {
         // Se selecionou uma divisão, usar IDDIVISAO
         companyId = "NULL";
         divisionId = this.reportCompanySelected.id.toString();
         console.log(`Configurado IDEMPRESA: NULL, IDDIVISAO: ${divisionId}`);
       }
       console.log('=== FIM CONFIGURAÇÃO ===');
     } else if (
       this.controlCompany.value &&
       typeof this.controlCompany.value === "object"
     ) {
       // Usar lógica padrão para dropdowns normais
       console.log('=== CONFIGURANDO EMPRESA/DIVISÃO PADRÃO ===');
       if (
         values.selectCompany === "Filial" ||
         values.selectCompany === "Matriz"
       ) {
         companyId = this.controlCompany.value.id;
         console.log(`Configurado IDEMPRESA: ${companyId}`);
       }
       if (values.selectCompany === "Divisão") {
         divisionId = this.controlCompany.value.id;
         console.log(`Configurado IDDIVISAO: ${divisionId}`);
       }
       console.log('=== FIM CONFIGURAÇÃO ===');
     }

    let reportEngine: ReportEngineModel = new ReportEngineModel();

         reportEngine.reportTypeUuid = values.typeReport;
     
           // Preparar IDTERMINALS como array JSON
      let terminalsArray = [];
      if (terminals && Array.isArray(terminals) && terminals.length > 0) {
        terminalsArray = terminals;
      }
      
      // Log dos valores finais que serão enviados
      console.log('=== VALORES FINAIS DO RELATÓRIO ===');
      console.log('IDEMPRESA:', companyId);
      console.log('IDDIVISAO:', divisionId);
      console.log('MODELORELATORIO:', values.modelReport);
      console.log('DATAINICIO:', dateStart);
      console.log('DATAFIM:', dateEnd);
      console.log('XLSX:', fileExcel);
      console.log('PDF:', filePdf);
      console.log('SALTOGPS:', gpsJump);
      console.log('REMOVERKM:', removeKm);
      console.log('BUSCARDIVISAO:', searchDivision);
      console.log('LATITUDE:', latitude);
      console.log('LONGITUDE:', longitude);
      console.log('RAIO:', radius);
      console.log('VELOCIDADE:', velocity);
      console.log('IDTERMINALS (array):', terminalsArray);
      console.log('RFIDPASSAGEIRO:', rfidPassenger);
      console.log('=== FIM VALORES ===');
      
      const mesAnoJson = referenceMonthYear
        ? `"MESANOREFERENCIA": "${referenceMonthYear}",`
        : "";

      reportEngine.parameter = `{
            "IDEMPRESA": "${companyId}",
            "IDDIVISAO": "${divisionId}",
            "MODELORELATORIO": "${values.modelReport}",
            ${mesAnoJson}
            "DATAINICIO": "${dateStart}",
            "DATAFIM": "${dateEnd}",
            "XLSX": "${fileExcel}",
            "PDF": "${filePdf}",
            "SALTOGPS": "${gpsJump}",
            "REMOVERKM": "${removeKm}",
            "BUSCARDIVISAO": "${searchDivision}",
            "LATITUDE": "${latitude}",
            "LONGITUDE": "${longitude}",
            "RAIO": "${radius}",
            "VELOCIDADE": "${velocity}",
            "IDTERMINALS": ${JSON.stringify(terminalsArray)},
            "RFIDPASSAGEIRO": "${rfidPassenger}"
          }`;

    reportEngine.requestOperator = storageX
      .whereKeyIs(STORAGE_KEY_CURRENT_USER)
      .get()?.id;

    console.log(reportEngine);

    this.reportEngineService.saveReport(reportEngine).subscribe((t) => {
      this.reportEngineModel = toCamel(t) as ReportEngineModel;
    });

    this.spinner.hide();
    this.handleReport();
  }

  public async handleReport(): Promise<void> {
    Swal.fire({
      icon: "success",
      title: "Rélatorio está em Processamento!",
      html: `<h6>Deseja ir para tela de consulta de relatorios?</h6>`,
      showCloseButton: false,
      showCancelButton: true,
      reverseButtons: true,
      cancelButtonText: "Não",
      showConfirmButton: true,
      confirmButtonText: "Sim",
      focusConfirm: false,
    }).then((action) => {
      if (action.isConfirmed) {
        this.router.navigate(["/relatorios"]);
      }
    });
  }

  // Métodos para verificar a visibilidade e obrigatoriedade dos campos
  isDateStartVisible(): boolean {
    return (
      !this.isReferenceMonthVisible() &&
      (this.validFieldsReport.find((field) => field.name === "DATAINICIO")
        ?.active ||
        false)
    );
  }

  isDateEndVisible(): boolean {
    return (
      !this.isReferenceMonthVisible() &&
      (this.validFieldsReport.find((field) => field.name === "DATAFIM")
        ?.active ||
        false)
    );
  }

  isReferenceMonthVisible(): boolean {
    return (
      this.validFieldsReport.find((field) => field.name === "MESANOREFERENCIA")
        ?.active || false
    );
  }

  isReferenceMonthRequired(): boolean {
    return !this.validFieldsReport.find(
      (field) => field.name === "MESANOREFERENCIA"
    )?.optional;
  }

  isReportModelVisible(): boolean {
    return (
      this.validFieldsReport.find((field) => field.name === "MODELORELATORIO")
        ?.active || false
    );
  }

  isCompanyOrDivisionVisible(): boolean {
    return this.validFieldsReport.some(
      (field) =>
        (field.name === "IDEMPRESA" || field.name === "IDDIVISAO") &&
        field.active
    );
  }

  isRemoveKmVisible(): boolean {
    return (
      this.validFieldsReport.find((field) => field.name === "REMOVERKM")
        ?.active || false
    );
  }

  isGpsJumpsVisible(): boolean {
    return (
      this.validFieldsReport.find((field) => field.name === "SALTOGPS")
        ?.active || false
    );
  }

  isSearchDivisionVisible(): boolean {
    return (
      this.validFieldsReport.find((field) => field.name === "BUSCARDIVISAO")
        ?.active || false
    );
  }

  isSearchDivisionDisable(): boolean {
    return !this.validFieldsReport.find((field) => field.name === "BUSCARDIVISAO")
      ?.optional;
  }

  isSearchDivisionEnabled(): boolean {
    return this.reportingRuleForm.get("searchDivision")?.value === true;
  }

  public onSearchDivisionChange(): void {
    const selectedCompany = this.controlCompany.value;
    if (selectedCompany?.id) {
      this.filterTerminalsByCompany(
        selectedCompany.id,
        this.isSearchDivisionEnabled()
      );
      this.reportingRuleForm.get("terminals")?.setValue([]);
      this.controlTerminalFilter?.setValue("");
    }
  }

  private getDivisionsLinkedToCompany(companyId: number): number[] {
    return this.companys
      .filter(
        (company) =>
          company.cnpj == null && company.idEmpresaMatriz == companyId
      )
      .map((company) => company.id);
  }

  isFilePdfVisible(): boolean {
    return (
      this.validFieldsReport.find((field) => field.name === "PDF")?.active ||
      false
    );
  }

  isFileExcelVisible(): boolean {
    return (
      this.validFieldsReport.find((field) => field.name === "XLSX")?.active ||
      false
    );
  }

  isLatitudeVisible(): boolean {
    return (
      this.validFieldsReport.find((field) => field.name === "LATITUDE")
        ?.active || false
    );
  }

  isLongitudeVisible(): boolean {
    return (
      this.validFieldsReport.find((field) => field.name === "LONGITUDE")
        ?.active || false
    );
  }

  isRadiusVisible(): boolean {
    return (
      this.validFieldsReport.find((field) => field.name === "RAIO")?.active ||
      false
    );
  }

  isVelocityVisible(): boolean {
    return (
      this.validFieldsReport.find((field) => field.name === "VELOCIDADE")
        ?.active || false
    );
  }

  isTerminalsVisible(): boolean {
    return (
      this.validFieldsReport.find((field) => field.name === "IDTERMINALS")
        ?.active || false
    );
  }

  isDateStartRequired(): boolean {
    return !this.validFieldsReport.find((field) => field.name === "DATAINICIO")
      ?.optional;
  }

  isDateEndRequired(): boolean {
    return !this.validFieldsReport.find((field) => field.name === "DATAFIM")
      ?.optional;
  }

  isReportModelRequired(): boolean {
    return !this.validFieldsReport.find(
      (field) => field.name === "MODELORELATORIO"
    )?.optional;
  }

  isLatitudeRequired(): boolean {
    return !this.validFieldsReport.find((field) => field.name === "LATITUDE")
      ?.optional;
  }

  isLongitudeRequired(): boolean {
    return !this.validFieldsReport.find((field) => field.name === "LONGITUDE")
      ?.optional;
  }

  isRadiusRequired(): boolean {
    return !this.validFieldsReport.find((field) => field.name === "RAIO")
      ?.optional;
  }

  isVelocityRequired(): boolean {
    return !this.validFieldsReport.find((field) => field.name === "VELOCIDADE")
      ?.optional;
  }

  isTerminalsRequired(): boolean {
    return !this.validFieldsReport.find((field) => field.name === "IDTERMINALS")
      ?.optional;
  }

  isCompanyOrDivisionRequired(): boolean {
    return this.validFieldsReport.some(
      (field) =>
        (field.name === "IDEMPRESA" || field.name === "IDDIVISAO") &&
        !field.optional
    );
  }

  isRemoveKmDisable(): boolean {
    return !this.validFieldsReport.find((field) => field.name === "REMOVERKM")
      ?.optional;
  }

  isGpsJumpsDisable(): boolean {
    return !this.validFieldsReport.find((field) => field.name === "SALTOGPS")
      ?.optional;
  }

  isFilePdfDisable(): boolean {
    return !this.validFieldsReport.find((field) => field.name === "PDF")
      ?.optional;
  }

  isFileExcelDisable(): boolean {
    return !this.validFieldsReport.find((field) => field.name === "XLSX")
      ?.optional;
  }

  isRfifPassengerVisible(): boolean {
    return (
      this.validFieldsReport.find((field) => field.name === "RFIDPASSAGEIRO")
        ?.active || false
    );
  }

  isRfifPassengerRequired(): boolean {
    return !this.validFieldsReport.find(
      (field) => field.name === "RFIDPASSAGEIRO"
    )?.optional;
  }

  /**
   * Verifica se é o relatório de status de bateria
   * @returns true se for o relatório de status de bateria
   */
  public isBatteryStatusReport(): boolean {
    return this.modelReportSelected === "Relatório Status Bateria para Rastreadores de Carga";
  }

  /**
   * Verifica se é o relatório de status de bateria baseado no tipo selecionado
   * @returns true se for o relatório de status de bateria
   */
  public isBatteryStatusReportType(): boolean {
    if (!this.typeReportSelected) return false;
    
    const selectedReportType = this.reportTypes.find(
      (report) => report.uuid === this.typeReportSelected
    );
    
    return selectedReportType?.name === "Relatório Status Bateria para Rastreadores de Carga";
  }
}
